// @todo: Migrate to 'Select' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Select} from '@wandb/weave/components/Form/Select';
// @todo: Migrate to 'TextField' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {TextField} from '@wandb/weave/components/Form/TextField';
// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon} from '@wandb/weave/components/Icon';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import React, {useState} from 'react';

interface OptionType {
  label: string;
  value: any;
}

export enum FilterValueTypes {
  String,
  Number,
  Boolean,
  AnyValue,
}

const filterValueTypeOptions: OptionType[] = [
  {label: 'String', value: FilterValueTypes.String},
  {label: 'Number', value: FilterValueTypes.Number},
  {label: 'Boolean', value: FilterValueTypes.Boolean},
  {label: 'Any Value', value: FilterValueTypes.AnyValue},
];

interface FilterRowProps {
  filter: FilterInfo;
  addFilter: (type: FilterValueTypes, key?: string, value?: string) => void;
  deleteFilter: () => void;
}

export type FilterInfo = {
  id: number;
  key?: string;
  value?: string;
  type: FilterValueTypes;
};

export const FilterRow = (props: FilterRowProps) => {
  const [filterValType, setFilterValType] = useState<FilterValueTypes>(
    FilterValueTypes.String
  );
  const {filter, addFilter, deleteFilter} = props;
  return (
    <Tailwind>
      <div className="flex gap-8">
        <div className="w-[183px]">
          <TextField
            value={filter.key ?? ''}
            placeholder="Metadata key"
            onChange={keyVal => {
              addFilter(filter.type, keyVal, filter.value);
            }}
          />
        </div>
        <div className="text-center	leading-8">=</div>

        <div className="w-[183px]">
          <Select<OptionType>
            options={filterValueTypeOptions}
            defaultValue={
              filter.type
                ? filterValueTypeOptions[filter.type]
                : filterValueTypeOptions[FilterValueTypes.String]
            }
            onChange={selected => {
              if (selected != null) {
                setFilterValType(selected.value);
                addFilter(selected.value, filter.key, filter.value);
              }
            }}
          />
        </div>

        <div className="w-[183px]">
          {filter.type !== FilterValueTypes.AnyValue && (
            <TextField
              value={filter.value ?? ''}
              placeholder="Metadata value"
              onChange={(val: string) => {
                addFilter(filter.type, filter.key, val);
              }}
            />
          )}
        </div>

        <div className="flex h-32 items-center justify-center">
          <Icon
            name="close"
            className="inline cursor-pointer items-center text-center leading-8"
            onClick={deleteFilter}
          />
        </div>
      </div>
    </Tailwind>
  );
};
